import React, { FC } from 'react';

import { ContactsDisplayMode } from '../hooks/use-contacts-variant';
import useContacts from './contacts-hooks';
import ContactsScene from './contacts-scene';
import { ContactKind } from './types';

const Contacts: FC = () => {
  const {
    t,
    history,
    parties,
    searchText,
    setSearchText,
    searchState,
    isFetching,
    displayMode,
    canToggleDisplayMode,
    dialogFullScreen,
    setDisplayMode,
    columns,
    createModalOpen,
    setCreateModalOpen,
    contactKind,
    setContactKind
  } = useContacts();

  const handleUserCreateModal = (state: boolean, kind: ContactKind) => {
    setCreateModalOpen(state);
    setContactKind(kind);
  };

  const handleDisplayMode = (mode: ContactsDisplayMode): void => setDisplayMode(mode);

  const handleSearch = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ): void => setSearchText(event.target.value);

  const handleEditNav = (id): void => history.push(`/contacts/${id}`);

  return (
    <ContactsScene
      t={t}
      columns={columns}
      parties={parties}
      displayMode={displayMode}
      canToggleDisplayMode={canToggleDisplayMode}
      searchText={searchText}
      searchState={searchState}
      isFetching={isFetching}
      dialogFullScreen={dialogFullScreen}
      createModalOpen={createModalOpen}
      handleDisplayMode={handleDisplayMode}
      handleSearch={handleSearch}
      handleEditNav={handleEditNav}
      handleUserCreateModal={handleUserCreateModal}
      contactKind={contactKind}
    />
  );
};

export default Contacts;
